import { useSnackbar } from '@app/hooks/useSnackbar';
import { NotificationModal } from '@components/ui';
import SignatureInput from '@components/ui/Signature/SignatureInput';
import { useSignSignatureRequestMutation } from '@dieterApi/signature/useSignatureRequestSignMutation';
import { useState } from 'react';
import { SignatureProps } from './SignatureButton';
import { SignatureSuccess } from './SignatureSuccess';

interface SignatureModalProps extends SignatureProps {
  isOpen: boolean;
  onClose: () => void;
}

export function SignatureModal(props: SignatureModalProps) {
  const [submitSignature] = useSignSignatureRequestMutation();
  const { enqueueSnackbar } = useSnackbar();

  const [hasSigned, setHasSigned] = useState(false);

  const onSubmit = (signaturePngDataUrl: string) => {
    submitSignature({
      variables: {
        token: props.jwt,
        image: signaturePngDataUrl,
      },
    })
      .then(() => setHasSigned(true))
      .catch((error) => {
        enqueueSnackbar(error, { variant: 'error' });
      });
  };

  return (
    <NotificationModal open={props.isOpen} withCloseButton={false} maxWidth="600px" withDieter={false}>
      {!hasSigned ? <SignatureInput name={props.tokenInfo.signerName} onSubmit={onSubmit} /> : <SignatureSuccess />}
    </NotificationModal>
  );
}
